import { Box, Button } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogState } from '~/hooks/useDialogState';
import {
  EmployeeProposalsDialog,
  EmployeeProposalsTabs,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog';
import { EmployeeRewardingProposalDialogTabs } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/data';

type PropsType = {
  enabledProposalDialogTabs: EmployeeRewardingProposalDialogTabs[];
};

export const GeneralTab = (props: PropsType) => {
  const { enabledProposalDialogTabs } = props;
  const { t } = useTranslation();
  const { isOpen, open, close } = useDialogState();

  return (
    <Box>
      TBA tab content: GeneralTab{' '}
      <Button onClick={open}>{t('baseSalaryProposal')}</Button>
      <EmployeeProposalsDialog
        open={isOpen}
        onClose={close}
        openOnTab={EmployeeProposalsTabs.SalaryProposal}
        enabledDialogTabs={enabledProposalDialogTabs}
      />
    </Box>
  );
};
